import { apiClient } from "services/api-client"

export const getTotalCountUserNotification = async (
  userId,
  tenant
) => {
  return await apiClient.get(`/user-notification/total-count?userId=${userId}&companyKey=${tenant}`)
}

export const getUserNotifications = async (
  userId,
  tenant,
  page,
  perPage,
  titleSearchContent,
  status = 'unread'
) => {
  return await apiClient.get(`/user-notification?userId=${userId}&companyKey=${tenant}&page=${page}&perPage=${perPage}&titleSearchContent=${titleSearchContent}&status=${status}`)
}

export const markNotificationAsRead = async (notificationId, userId) => {
  return await apiClient.put(`/user-notification/${notificationId}/read?userId=${userId}`)
}

export const markAllNotificationsAsRead = async (userId, tenant) => {
  return await apiClient.put(`/user-notification/read-all?userId=${userId}&companyKey=${tenant}`)
}

export const archiveNotification = async (notificationId, userId) => {
  return await apiClient.put(`/user-notification/${notificationId}/archive?userId=${userId}`)
}
